import React from "react";
import { Container, Row, Col, Navbar } from "react-bootstrap";

// import Image
import logoLight from "../../assets/images/logo-light.png";
// import logoDark from "../../assets/images/logo-dark.png";

import { Link } from "react-router-dom";
import styles from "./Footer.module.scss";
import useLang from "hooks/useLang";

const Footer = () => {
  const { lang } = useLang()

  return (
    <React.Fragment>
      <section className={styles.footerDetails}>
        <div
          className="mb-4"
          style={{
            padding: "10px 50px",
            backgroundColor: "orange"
          }}
        >
          <Row className="container m-auto justify-space-between p-0">
            <p className="w-fit align-center mr-4 subscribe" style={{ fontSize: "15px", fontWeight: "bold", color: "black" }}>
              {lang.footer.cta_bar}
            </p>
            <Link
              className="btn bg-dark w-fit px-3 ml-3 subscribe"
              to="https://api.whatsapp.com/send?phone=6281188030203&amp;text=Halo%20Admin%2C%20saya%20sedang%20membutuhkan%20jasa%20perpajakan.%20Apakah%20boleh%20dibantu%3F"
              target="_blank"
              rel="noreferrer"
              >
              {lang.footer.cta_1} <i className="uil uil-angle-right" />
            </Link>
          </Row>
        </div>
        <Container>
          <Row>
            <Col md={6} className="mb-4">
              <h3>{lang.footer.about_us}</h3>
              <p>
                {lang.footer.about_us_detail}
              </p>
            </Col>
            <Col md={6} className={styles.contacts}>
              <h3>{lang.footer.our_contact}</h3>
              <ul>
                <li>
                  <span>
                    <i className="uil uil-location-point" />
                  </span>
                  <p>The Iconic Building, Jalan Sentosa Raya No. 59, Sukmajaya, Depok Tengah II, Depok, Jawa Barat, 16411</p>
                </li>
                {/* <li>
                  <span>
                    <i className="uil uil-location-point" />
                  </span>
                  <p>Gedung Graha Mahri, Jalan Akses UI No 24D Kel Tugu Kec Cimanggis Kota Depok, Jawa Barat</p>
                </li> */}
                <li>
                  <span>
                    <i className="uil uil-phone" />
                  </span>
                  <p>+62 21-3875-2066</p>
                </li>
                <li>
                  <span>
                    <i className="uil uil-whatsapp" />
                  </span>
                  <p>+62 811-8803-0203</p>
                </li>
                <li>
                  <span>
                    <i className="uil uil-envelope" />
                  </span>
                  <p>solutions@iconictax.id</p>
                </li>
              </ul>
            </Col>
          </Row>
        </Container>
        <Container style={{ marginTop: "50px" }}>
          <Row className="justify-content-center">
            <Col lg={10} className="text-center">
              <Navbar.Brand className="logo text-uppercase" href="index-1.html">
                <img src={logoLight} className="logo-light" alt="" height="30" />
                <img src={logoLight} className="logo-dark" alt="" height="30" />
              </Navbar.Brand>

              <div className="footer-icon mt-4 d-flex justify-content-center">
                <div className="d-flex align-items-center">
                  <Link target="_blank" to="https://www.instagram.com/adinata.konsultanpajak/" className="me-2 avatar-sm text-center" data-bs-toggle="tooltip" data-bs-placement="top" title="Instagram">
                    <i className="mdi mdi-instagram f-24 align-middle icon-adinata"></i>
                  </Link>
                  {/* <Link to="#" className="me-2 avatar-sm text-center" data-bs-toggle="tooltip" data-bs-placement="top" title="Facebook">
                    <i className="mdi mdi-facebook f-24 align-middle icon-adinata"></i>
                  </Link> */}
                  {/* <Link to="#" className="mx-2 avatar-sm text-center" data-bs-toggle="tooltip" data-bs-placement="top" title="twitter">
                    <i className="mdi mdi-twitter f-24 align-middle icon-adinata"></i>
                  </Link> */}
                  <Link target="_blank" to="https://www.tiktok.com/@adinatataxconsulting?is_from_webapp=1&sender_device=pc" className="mx-2 avatar-sm text-center" data-bs-toggle="tooltip" data-bs-placement="top" title="TikTok">
                    <i className="fa-brands fa-tiktok f-24 align-middle icon-adinata"></i>
                  </Link>
                  {/* <Link to="#" className="mx-2 avatar-sm text-center">
                    <i
                      className="mdi mdi-linkedin f-24 align-middle icon-adinata"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="linkedin"
                    ></i>
                  </Link> */}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/* <hr /> */}
    </React.Fragment>
  );
};

export default Footer;
